import type { CurrencyAmount } from '@omnipresentgroup/design-system';
import type { Country } from '@omnipresentgroup/types';

export enum ClientPolicyUnit {
  DAY = 'DAY',
  WEEK = 'WEEK',
}

export enum ClientPolicyCategory {
  STATUTORY = 'STATUTORY',
  CUSTOM = 'CUSTOM',
}

export enum LeaveTypeEnum {
  SICK = 'SICK',
}

export enum PayTypeEnum {
  PERCENTAGE = 'PERCENTAGE',
  FIXED = 'FIXED',
}

export type ClientPolicyCountry = Omit<Country, 'flag'>;

export type ClientPolicyPeriod = {
  start: number;
  end: number;
  unit: ClientPolicyUnit;
  payDetails:
    | { payType: PayTypeEnum.PERCENTAGE; percentageValue: number }
    | { payType: PayTypeEnum.FIXED; fixedValue: CurrencyAmount };
};

export type ClientPolicyDescriptionItem = string | string[];

export type ClientPolicyExplanationItem = {
  title: string;
  descriptionItems: ClientPolicyDescriptionItem[];
};

export type ClientPolicy = {
  type: LeaveTypeEnum;
  category: ClientPolicyCategory;
  country: ClientPolicyCountry;
  description: string;
  extraDescription?: string;
  notice?: string;
  periods: Array<ClientPolicyPeriod>;
  customMinimum: ClientPolicyPeriod | null;
  clientPolicyExplanations?: ClientPolicyExplanationItem[];
};

export type GetClientPolicyResponse = ClientPolicy[];
